import { render, staticRenderFns } from "./MilestoneVisits.vue?vue&type=template&id=64674469&scoped=true&"
import script from "./MilestoneVisits.vue?vue&type=script&lang=js&"
export * from "./MilestoneVisits.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneVisits.vue?vue&type=style&index=0&id=64674469&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64674469",
  null
  
)

export default component.exports